import type { FaireProductEntity } from "../../entity_types/product";

export const p_97wtvnh6fr: FaireProductEntity = {
  token: "p_97wtvnh6fr",
  type: "product",
  name: "Berry Bliss Power Mist Hydrating Hand Sanitizer",
  brandToken: "b_evrq835k7x",
  brandName: "Touchland",
  imageUrl:
    "https://cdn.faire.com/fastly/9f20f117229ab6301fc11cbd4b219ed46af60fc47ec846532048dd37e8ce86c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d5ece8c47ca524225ad14392cf835d2f6da8fa3ea3533b42e38f591ef92c3589.jpeg",
    "https://cdn.faire.com/fastly/21f4935afe64374caa019061dea62e34730028b21a76782b779fa0a54ad3332a.jpeg",
    "https://cdn.faire.com/fastly/33a50f301074d73d7f0cd54f94b917fd5e11b7cc259341f20ff00b2eb5064bc2.jpeg",
    "https://cdn.faire.com/fastly/ab144e65cfe428e8558f73cf73c7f39cb3ffb46998ab6dd7e4c7b281a531542a.jpeg",
    "https://cdn.faire.com/fastly/f2a16c923e0a4e025c8ab77e7d6056dfde96224e7efe6aa897fc2c46cfee044f.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "A skincare-forward hand sanitizer that leaves hands sanitized, hydrated, and delicately scented.\n\nBerry Bliss Scent: Lush and joyful. Ripe strawberries and juicy black raspberry blend with violet petals, capturing the brightness of a berry-kissed meadow.\n\nTop Notes: Ripe Strawberries, Crisp Apple, Garden Rhubarb.\nHeart Notes: Watery Black Raspberry, Fuzzy Peaches.\nBase Notes: Violet Petals, Vanilla Bean, Sweet Musks.\n\n𝐌𝐚𝐢𝐧 𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\n• Alcohol: Effective against most common bacteria.\n• Aloe Vera: Helps hydrate skin and leaves a non-greasy finish.\n• Radish Root Ferment Filtrate: Helps enhance skin’s moisture retention.\n\n𝐁𝐞𝐧𝐞𝐟𝐢𝐭𝐬:\n• Hydrating - Enriched with Aloe Vera to help hydrate skin.\n• Uplifting scent - Available in 15+ scents.\n• Lightweight - Non-sticky and fast-absorbing formula delivered in a micro-mist.\n• Free from phthalates and sulfates.\n• Vegan and cruelty-free.\n• Dermatologically tested.\n• Travel-friendly 1 FL. OZ. (30 mL).",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:41.152Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
